module.exports = __webpack_public_path__ + "static/media/img-excl-living-03dorms.bc072823.jpg";